export default {
  irPerDate: 'IR_PER_DATE',
};
